import ENV from "config/Env";
import { typedQueryClient, useTypedMutation } from "hooks";
import { CommunicationSettingsQueryKeys } from "modules/CommunicationSettings/queryKeys";
import { ApiInstance } from "utils/Api";

import type { CommunicationSetting } from "models";

export const useCommunicationSettingsMutation = () =>
  useTypedMutation<CommunicationSetting, void>({
    mutationFn: async settings => (await ApiInstance.post("/communication/settings/update", { settings }, ENV.dealerBaseURL)).data,
    onSuccess: payload => {
      const settings = typedQueryClient.getQueryData(CommunicationSettingsQueryKeys.settings);
      if (!settings) return;

      typedQueryClient.setQueryData(CommunicationSettingsQueryKeys.settings, { ...settings, ...payload });
    }
  });
